import React from 'react';

import { 
  Skill,
  SKILL_OPTIONS,
} from "@dndModels";
import { 
  ABILITY_SCORES_EXPANDED 
} from "@dndModels/Constants";
import { DisablableOption } from "@models";

import SelectStringBox from "@components/input/selects/SelectStringBox";

interface Props {
  name: string;
  value?: string;
  multiple?: boolean;
  allow_all?: boolean;
  allow_ability_scores?: boolean;
  options?: string[];
  values?: string[];
  skills?: Skill[];
  onChange: Function;
  color?: string;
  ignore_us?: string[];
  disabled?: boolean;
}

const SelectSkillBox = ({
  name,
  value = "",
  multiple = false,
  allow_all = false,
  allow_ability_scores = false,
  options = [],
  values = [],
  onChange,
  color = "",
  ignore_us = [],
  disabled = false
}: Props) => {
  const buildSkills = (): DisablableOption[] => {
    let skills: DisablableOption[] = options.length > 0
      ? options.flatMap(o => {
          const found = SKILL_OPTIONS.find(s => s.id === o);
          return found ? [found] : [];
        })
      : [...SKILL_OPTIONS];

    if (allow_ability_scores) {
      const ability_scores: DisablableOption[] = ABILITY_SCORES_EXPANDED
        .filter(o => o !== "None")
        .map(ability => ({ id: ability, text: ability }));
      skills = [...ability_scores, ...skills];
    }

    skills = skills.filter(o => !ignore_us.includes(o.id));

    if (skills.length === 0) {
      skills = SKILL_OPTIONS.filter(o => !ignore_us.includes(o.id));
    }

    return skills;
  };

  const skills = buildSkills();

  if (multiple) {
    return (
      <SelectStringBox
        options={skills}
        multiple
        allow_all={allow_all}
        values={values}
        name={name}
        disabled={disabled}
        onChange={(ids: string[]) => onChange(ids)}
      />
    );
  }

  return (
    <SelectStringBox
      options={skills}
      value={value}
      name={name}
      color={color}
      allow_all={allow_all}
      disabled={disabled}
      onChange={(id: string) => onChange(id)}
    />
  );
};

export default SelectSkillBox;